<template>
  <z-card class="takeaways">
    <z-title
      tag="h2"
      class="takeaways__title"
    >
      Principais conclusões
    </z-title>

    <ul class="takeaways__list">
      <li
        v-for="takeaway in takeaways"
        :key="takeaway.content"
        class="takeaways__list-item"
      >
        {{ takeaway.content }}
      </li>
    </ul>
  </z-card>
</template>

<script>
export default {
  name: 'LessonTakeaways',
  props: {
    takeaways: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.takeaways {
  padding: var(--unit-0600)
}

.takeaways__title {
  margin: 0 0 var(--unit-0300)
}

.takeaways__list {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  padding-left: var(--unit-0600);
  row-gap: var(--unit-0400);
}
</style>
